var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "BasePopover",
    _vm._g(
      _vm._b(
        {
          scopedSlots: _vm._u(
            [
              {
                key: "popover",
                fn: function () {
                  return [_vm._t("popover")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        "BasePopover",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }